export const formatCurrency = (
    value: number,
    currencyCode = 'USD',
    locale = 'en-US',
) => {
    let formattedValue

    if (value >= 1_000_000_000) {
        formattedValue = '$' + (value / 1_000_000_000).toFixed(2) + 'B'
    } else if (value >= 1_000_000) {
        formattedValue = '$' + (value / 1_000_000).toFixed(2) + 'M'
    } else if (value >= 1_000) {
        formattedValue = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value)
    } else {
        formattedValue = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value)
    }

    return formattedValue
}

export const formatCurrencyString = (value: string | number): string => {
    const strValue = String(value).trim()

    if (strValue.startsWith('-')) {
        const withoutNegative = strValue.slice(1)
        return `(${withoutNegative})`
    }

    return strValue // Preserve commas and original formatting
}

export const formatTransactions = (value: number, locale = 'en-US') => {
    let formattedValue

    if (value >= 1_000_000_000) {
        formattedValue = (value / 1_000_000_000).toFixed(2) + 'B'
    } else if (value >= 1_000_000) {
        formattedValue = (value / 1_000_000).toFixed(2) + 'M'
    } else {
        formattedValue = new Intl.NumberFormat(locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value)
    }

    return formattedValue
}
